"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimensionCompoundValueParser = exports.keywordsCompoundValueParser = exports.identityCompoundValueParser = void 0;
var css_data_types_1 = require("../css-data-types");
var identityCompoundValueParser = function (text) { return text; };
exports.identityCompoundValueParser = identityCompoundValueParser;
var keywordsCompoundValueParser = function (keywords) {
    return function (text) {
        return typeof keywords === 'string' ? text === keywords : keywords.has(text);
    };
};
exports.keywordsCompoundValueParser = keywordsCompoundValueParser;
var dimensionCompoundValueParser = function (text) { var _a; return (_a = (0, css_data_types_1.parseDimension)(text)) !== null && _a !== void 0 ? _a : css_data_types_1.EMPTY_DIMENSION; };
exports.dimensionCompoundValueParser = dimensionCompoundValueParser;
//# sourceMappingURL=compound-value-parsers.js.map